"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddedAppService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var angular_utils_1 = require("../util/angular/angular-utils");
var EmbeddedAppService = /** @class */ (function () {
    function EmbeddedAppService() {
    }
    EmbeddedAppService.prototype.getIntegratorContext = function () {
        var _a, _b;
        return JSON.parse(((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.EmbeddedPage) === null || _b === void 0 ? void 0 : _b.seismicIntegratorContext) || '{}');
    };
    EmbeddedAppService.prototype.saveCurrentStateToSessionStorage = function () {
        var _a, _b, _c, _d;
        var currentState = angular_utils_1.getInjector().get('$state');
        if (!((_a = window) === null || _a === void 0 ? void 0 : _a.EmbeddedPage.config) || !((_b = window) === null || _b === void 0 ? void 0 : _b.EmbeddedPage.config.currentId))
            return;
        (_c = window) === null || _c === void 0 ? void 0 : _c.sessionStorage.setItem((_d = window) === null || _d === void 0 ? void 0 : _d.EmbeddedPage.config.currentId, JSON.stringify({
            currentStateName: currentState.current.name,
            params: currentState.params,
        }));
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    EmbeddedAppService.prototype.postMessage = function (type, data) {
        var _a, _b, _c;
        if (((_a = window) === null || _a === void 0 ? void 0 : _a.EmbeddedPage) && ((_b = window) === null || _b === void 0 ? void 0 : _b.EmbeddedPage.PostMan)) {
            (_c = window) === null || _c === void 0 ? void 0 : _c.EmbeddedPage.PostMan.remoteCall('action', {
                type: type,
                data: data,
            });
        }
        else {
            console.log('No communication object available.');
        }
    };
    /**
     * Returns true if the Seismic Web App is hosted in an iframe in an embedded application such as Salesforce
     */
    EmbeddedAppService.prototype.isEmbeddedApp = function () {
        var EmbeddedPage = window.EmbeddedPage;
        return !!EmbeddedPage;
    };
    EmbeddedAppService = __decorate([
        CommonService_decorator_1.CommonService('EmbeddedAppService')
    ], EmbeddedAppService);
    return EmbeddedAppService;
}());
exports.EmbeddedAppService = EmbeddedAppService;
//# sourceMappingURL=EmbeddedApp.service.js.map